$.isSet = function (object) {
  return typeof object !== "undefined" && object !== "" && object !== null
}

// Init select2
$(".filters-select").select2({
  minimumResultsForSearch: -1,
})

// Showing submenu
$(".js-open-submenu").on("mouseenter click", function (event) {
  var $this = $(this)

  var submenuName = $this.attr("data-submenu-name")
  var $subenuBox = $(".header .submenu-" + submenuName)

  $(".header .js-open-submenu").removeClass("active")
  $(
    '.header .js-open-submenu[data-submenu-name="' + submenuName + '"]'
  ).addClass("active")

  $(".header .submenu-box").hide()
  $subenuBox.show()
})

// Hiding submenu
$(".header").on("mouseleave", function (event) {
  $(".header .js-open-submenu").removeClass("active")
  $(".submenu-box").hide()
})
$(".close-submenu").on("click", function (event) {
  $(".header .js-open-submenu").removeClass("active")
  $(".submenu-box").hide()
})

// Product Page
$(".js-quantity-add").on("click keypress", function (e) {
  var $qtyInput = $(this).parents(".quantity-box").find("input")
  if (('keyCode' in e && e.keyCode === 13) || typeof(e.keyCode) === 'undefined') {
    if ($qtyInput.length > 0) {
      if ($.isSet($qtyInput.val())) {
        if (isNaN(parseInt($qtyInput.val()))) {
          $qtyInput.val(1)
        }
  
        $qtyInput.val(parseInt($qtyInput.val()) + 1)
      } else {
        $qtyInput.val(0)
      }
    }
  }
})
$(".js-quantity-remove").on("click keypress", function (e) {
  var $qtyInput = $(this).parents(".quantity-box").find("input")
  if (('keyCode' in e && e.keyCode === 13) || typeof(e.keyCode) === 'undefined') {
    if ($qtyInput.length > 0) {
      if ($.isSet($qtyInput.val())) {
        if (isNaN(parseInt($qtyInput.val()))) {
          $qtyInput.val(1)
        }
  
        var newVal = parseInt($qtyInput.val()) - 1
  
        if (newVal < 1) {
          newVal = 1
        }
  
        $qtyInput.val(newVal)
      } else {
        $qtyInput.val(0)
      }
    }
  }
})

$('input[name="quantity"]').on("change", function () {
  var $this = $(this)
  var val = $this.val()

  if (!$.isSet(val)) {
    $this.val(1)
    val = 1
  }

  if (isNaN(parseInt($this.val()))) {
    $this.val(1)
    val = 1
  }
})

function setMarquiseSpacerHeight() {
  var spacer = document.querySelector(".marquise-spacer");
  var headerHeight = document.querySelector(".header").offsetHeight;
  spacer.style.height = headerHeight + "px"
  // if (window.innerWidth >= 980) {
  // } else {
  //   spacer.style.height = 0
  // }
}
setMarquiseSpacerHeight();
document.addEventListener("DOMContentLoaded", function() {
  setMarquiseSpacerHeight();
})
window.addEventListener("resize", function() {
  setMarquiseSpacerHeight();
})

var instaFeed = document.getElementById("insta-feed");
if (instaFeed) {
  var checkArrows = setInterval(function() {
    if (instaFeed.querySelectorAll(".slider-arrow").length > 0) {
      instaFeed.querySelectorAll(".slider-arrow").forEach((arrow) => {
        arrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.19 26.73"><defs><style>.d{isolation:isolate;}.e{fill:#b7b6b5;mix-blend-mode:multiply;opacity:.5;}</style></defs><g class="d"><g id="a"></g><g id="b"><g id="c"><path class="e" d="M12.07,.54L.53,12.07c-.71,.71-.71,1.87,0,2.58l11.53,11.53c1.15,1.15,3.12,.34,3.12-1.29V1.83c0-1.63-1.97-2.44-3.12-1.29Z"></path></g></g></g></svg>`;
      })
      clearInterval(checkArrows);
    }
  }, 500);
}

// move ADA tray icon 
if (window.timerADATray) clearInterval(window.timerADATray);
var adaCount = 0;
window.timerADATray = setInterval(function() {
  if (typeof($) !== 'undefined') {
    
    if ($("#ada_enable_toolbar_trigger").length) {
        // ada icon found, so move it to footer
        $("#ada_enable_toolbar_trigger").appendTo($("#shopify-section-deweys-footer .footer"));
        clearInterval(window.timerADATray);
    }
  }
  if (adaCount > 1500) {
    clearInterval(window.timerADATray);
  }
  else {
    adaCount = adaCount + 1;
  }
}, 100);

// product image zoom 
var productModal = document.getElementById('productModal');
var modalImg = document.getElementById("imgPlaceholder");
if (typeof(productModal) !== 'undefined' && productModal !== null) {
  var els = document.getElementsByClassName("product-main-image"); 
  // loops els
  for(var i = 0, x = els.length; i < x; i++) {
      els[i].onclick = function() {
        // Get the modal
        productModal.style.display = "block";
        modalImg.src = this.src;
        modalImg.alt = this.alt;
      }
  }


// When the user clicks on <span> (x), close the modal
  productModal.onclick = function() {
    modalImg.className += " product-modlal-out";
    setTimeout(function() {
       productModal.style.display = "none";
       modalImg.className = "product-modal-content";
     }, 400);
  }
}

//Carousel initiation 
if ($("#topCarousel").length) {
  //get date 
    var d = new Date(new Date().toLocaleString("en-US", {timeZone: "America/New_York"})),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    var todaysDate = [year, month, day].join('-');
    $("#topCarousel .carousel-inner .item").each(function() {
      $(this).removeClass("active");
      //console.log("checking item - ", $(this));
      var startDate = $(this).data("start-date");
      var expirationDate = $(this).data("expiration-date");
      //console.log("today: ", todaysDate, ", start: ", startDate, ", exp: ", expirationDate);
      var showItem = true;
      if (startDate) {
        if (todaysDate >= startDate) {
          showItem = true;
        }
        else {
          showItem = false;
        }
      }
      else {
        showItem = true;
      }
      if (showItem) {
        if (expirationDate) {
          if (todaysDate >= expirationDate) {
            showItem = false;
          }
          else {
            showItem = true;
          }
        }
        else {
          showItem = true;
        }
      }
      if (!showItem) {
        //remove this slide
        //console.log("removing item");
        $(this).remove();
        //remove indicator
        $('#topCarousel .carousel-indicators li:last-child').remove();
      }
    });
    //$('#topCarousel .carousel-indicators li:last-child').remove();
    //$('#topCarousel .carousel-inner .item:last-child').remove()
    $('#topCarousel .carousel-inner .item:first-child').addClass("active");
    //console.log("restarting carousel");
    $("#topCarousel").addClass("carousel");
    $("#topCarousel").addClass("slide");
    $(".carousel-box").fadeIn();//.css('dislplay', 'block');
    $('#topCarousel.carousel').carousel({
      interval: 8000
    });
}